(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mux", [], factory);
	else if(typeof exports === 'object')
		exports["mux"] = factory();
	else
		root["mux"] = factory();
})(global, () => {
return 